import React from 'react'
import { displayPopup, hidePopup } from '../../../store/map/map.actions'
import { selectAddresses, selectAddressContour } from '../../../store/address/address.selectors'
import { POPUP_TYPE_ADDRESS } from '../popup/popup.selectors'
import AddressMarker from './AddressMarker'
import { useSelector } from 'react-redux'
import { selectPopupType } from '../../../store/map/map.selectors'
import { useAction } from '../../utils/react-redux'
import { setAmbiguityAddress } from '../../../store/location/location.actions'

const AddressMarkersContainer = () => {
  const addresses = useSelector(selectAddresses)
  const popupType = useSelector(selectPopupType)
  const execHidePopup = useAction(hidePopup)
  const execDisplayPopupAddress = useAction(displayPopup)
  const execSetAmbiguityAddress = useAction(setAmbiguityAddress)

  const handleClickMarker = address => () => {
    if (addresses.length > 1) {
      execSetAmbiguityAddress(address)
    } else {
      popupType === POPUP_TYPE_ADDRESS ? execHidePopup() : execDisplayPopupAddress(POPUP_TYPE_ADDRESS)
    }
  }

  const contour = useSelector(selectAddressContour)

  if (!addresses?.length || contour) return <></>

  return (
    <div>
      {addresses.map(address => {
        const {
          coordinates: { lat, lng }
        } = address
        return <AddressMarker key={`${lng}-${lat}`} coordinates={{ lat, lng }} onClick={handleClickMarker(address)} />
      })}
    </div>
  )
}

export default AddressMarkersContainer
